/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ExtranetServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加配置信息
     * @param inDto (optional) 配置信息
     * @return OK
     */
    addDeviceExtranetConfig(inDto: DeviceExtranetConfigDTO | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/device-extranet/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddDeviceExtranetConfig(_response);
        });
    }

    protected processAddDeviceExtranetConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除配置信息
     * @param id (optional) ID
     * @return OK
     */
    delDeviceExtranetConfig(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/device-extranet/del/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelDeviceExtranetConfig(_response);
        });
    }

    protected processDelDeviceExtranetConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询设备的配置信息
     * @param workStationId (optional) 工位id
     * @return OK
     */
    queryDeviceExtranetConfigOutList(workStationId: string | null | undefined): Promise<DeviceExtranetConfigVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/device-extranet/query/{workStationId}";
        if (workStationId !== null && workStationId !== undefined)
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        else
            url_ = url_.replace("/{workStationId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryDeviceExtranetConfigOutList(_response);
        });
    }

    protected processQueryDeviceExtranetConfigOutList(response: AxiosResponse): Promise<DeviceExtranetConfigVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceExtranetConfigVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceExtranetConfigVO[]>(<any>null);
    }

    /**
     * 修改配置信息
     * @param id (optional) ID
     * @param inDto (optional) 配置信息
     * @return OK
     */
    updateDeviceExtranetConfig(id: string | null | undefined, inDto: DeviceExtranetConfigDTO | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/device-extranet/update/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateDeviceExtranetConfig(_response);
        });
    }

    protected processUpdateDeviceExtranetConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询工位
     * @param inDTO inDTO
     * @return OK
     */
    pageWorkStationExtranetInfo(inDTO: PageWorkStationDTO): Promise<PagedResultVOOfWorkStationExtranetInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet/device/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageWorkStationExtranetInfo(_response);
        });
    }

    protected processPageWorkStationExtranetInfo(response: AxiosResponse): Promise<PagedResultVOOfWorkStationExtranetInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfWorkStationExtranetInfoVO.fromJS(resultData200) : new PagedResultVOOfWorkStationExtranetInfoVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfWorkStationExtranetInfoVO>(<any>null);
    }

    /**
     * 根据工位组分页查询工位
     * @param inDTO inDTO
     * @return OK
     */
    pageWorkStationExtranetInfoByGroupId(inDTO: PageGroupWorkStationDTO): Promise<PagedResultVOOfWorkStationExtranetInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet/device/page/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageWorkStationExtranetInfoByGroupId(_response);
        });
    }

    protected processPageWorkStationExtranetInfoByGroupId(response: AxiosResponse): Promise<PagedResultVOOfWorkStationExtranetInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfWorkStationExtranetInfoVO.fromJS(resultData200) : new PagedResultVOOfWorkStationExtranetInfoVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfWorkStationExtranetInfoVO>(<any>null);
    }

    /**
     * 查询工位详情
     * @param workStationId workStationId
     * @return OK
     */
    getDeviceDetail(workStationId: string): Promise<WorkStationExtranetInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet/device/{workStationId}";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceDetail(_response);
        });
    }

    protected processGetDeviceDetail(response: AxiosResponse): Promise<WorkStationExtranetInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationExtranetInfoVO.fromJS(resultData200) : new WorkStationExtranetInfoVO();
            return result200;
        }
        return Promise.resolve<WorkStationExtranetInfoVO>(<any>null);
    }

    /**
     * 停止远程诊断
     * @param workStationId (optional) 工位id
     * @return OK
     */
    stopExtranet(workStationId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet/devices/stop-extranet/{workStationId}";
        if (workStationId !== null && workStationId !== undefined)
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        else
            url_ = url_.replace("/{workStationId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStopExtranet(_response);
        });
    }

    protected processStopExtranet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 生成远程诊断码
     * @param inDto inDto
     * @return OK
     */
    generateExtranetCode(inDto: GenerateExtranetCodeDTO): Promise<ExtranetCodeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet/generate-extranet-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGenerateExtranetCode(_response);
        });
    }

    protected processGenerateExtranetCode(response: AxiosResponse): Promise<ExtranetCodeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExtranetCodeVO.fromJS(resultData200) : new ExtranetCodeVO();
            return result200;
        }
        return Promise.resolve<ExtranetCodeVO>(<any>null);
    }

    /**
     * 获取远程诊断支持的协议集
     * @return OK
     */
    getSupportProtocols(): Promise<ProtocolVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet/protocols/support";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSupportProtocols(_response);
        });
    }

    protected processGetSupportProtocols(response: AxiosResponse): Promise<ProtocolVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProtocolVO.fromJS(resultData200) : new ProtocolVO();
            return result200;
        }
        return Promise.resolve<ProtocolVO>(<any>null);
    }

    /**
     * 反馈诊断结果
     * @param inDto inDto
     * @return OK
     */
    addExtranetRecord(inDto: DiagnosticRecordsDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet/records/feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddExtranetRecord(_response);
        });
    }

    protected processAddExtranetRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询远程诊断记录
     * @param inDto inDto
     * @return OK
     */
    getExtranetRecord(inDto: DiagnosticRecordsPageDTO): Promise<PagedResultVOOfDiagnosticRecordsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet/records/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetExtranetRecord(_response);
        });
    }

    protected processGetExtranetRecord(response: AxiosResponse): Promise<PagedResultVOOfDiagnosticRecordsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfDiagnosticRecordsVO.fromJS(resultData200) : new PagedResultVOOfDiagnosticRecordsVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfDiagnosticRecordsVO>(<any>null);
    }
}

export class DeviceServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询设备
     * @param input input
     * @return OK
     */
    findDeviceList(input: FindDeviceListDTO): Promise<PagedResultVOOfWorkStationExtranetInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/device/find-device-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindDeviceList(_response);
        });
    }

    protected processFindDeviceList(response: AxiosResponse): Promise<PagedResultVOOfWorkStationExtranetInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfWorkStationExtranetInfoVO.fromJS(resultData200) : new PagedResultVOOfWorkStationExtranetInfoVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfWorkStationExtranetInfoVO>(<any>null);
    }

    /**
     * findDeviceExtranetState
     * @param gatewayCode gatewayCode
     * @return OK
     */
    findDeviceExtranetState(gatewayCode: string): Promise<DeviceStateVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/device/findDeviceExtranetState?";
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindDeviceExtranetState(_response);
        });
    }

    protected processFindDeviceExtranetState(response: AxiosResponse): Promise<DeviceStateVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeviceStateVo.fromJS(resultData200) : new DeviceStateVo();
            return result200;
        }
        return Promise.resolve<DeviceStateVo>(<any>null);
    }
}

export class ExtranetParamSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getCurrentExtranetParamSetting
     * @return OK
     */
    getCurrentExtranetParamSetting(): Promise<ExtranetParamSetting> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet-param-setting/getCurrentExtranetParamSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentExtranetParamSetting(_response);
        });
    }

    protected processGetCurrentExtranetParamSetting(response: AxiosResponse): Promise<ExtranetParamSetting> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExtranetParamSetting.fromJS(resultData200) : new ExtranetParamSetting();
            return result200;
        }
        return Promise.resolve<ExtranetParamSetting>(<any>null);
    }

    /**
     * getExtranetParamSetting
     * @param tenantId tenantId
     * @return OK
     */
    getExtranetParamSetting(tenantId: string): Promise<ExtranetParamSetting> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet-param-setting/getExtranetParamSetting?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetExtranetParamSetting(_response);
        });
    }

    protected processGetExtranetParamSetting(response: AxiosResponse): Promise<ExtranetParamSetting> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExtranetParamSetting.fromJS(resultData200) : new ExtranetParamSetting();
            return result200;
        }
        return Promise.resolve<ExtranetParamSetting>(<any>null);
    }

    /**
     * saveExtranetParamSetting
     * @param input input
     * @return OK
     */
    saveExtranetParamSetting(input: ExtranetParamSetting): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet-param-setting/saveExtranetParamSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveExtranetParamSetting(_response);
        });
    }

    protected processSaveExtranetParamSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ExtranetRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * export
     * @param input input
     * @return OK
     */
    export(input: DiagnosticRecordsPageDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet-record/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ExtranetSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getExtranetSetting
     * @return OK
     */
    getExtranetSetting(): Promise<ExtranetSetting> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet-setting/getExtranetConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetExtranetSetting(_response);
        });
    }

    protected processGetExtranetSetting(response: AxiosResponse): Promise<ExtranetSetting> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExtranetSetting.fromJS(resultData200) : new ExtranetSetting();
            return result200;
        }
        return Promise.resolve<ExtranetSetting>(<any>null);
    }

    /**
     * saveExtranetSetting
     * @param extranetSetting extranetSetting
     * @return OK
     */
    saveExtranetSetting(extranetSetting: ExtranetSetting): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/extranet-setting/saveExtranetSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(extranetSetting);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveExtranetSetting(_response);
        });
    }

    protected processSaveExtranetSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class GatewayExtranetServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * bindFeature
     * @param input input
     * @return OK
     */
    bindFeature(input: BindFeatureDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/gateway_extranet/bind_feature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBindFeature(_response);
        });
    }

    protected processBindFeature(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * clear
     * @param workStationId workStationId
     * @return OK
     */
    clear(workStationId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/gateway_extranet/clear?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClear(_response);
        });
    }

    protected processClear(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * getFeature
     * @param workStationId workStationId
     * @return OK
     */
    getFeature(workStationId: string): Promise<GetFeatureVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/gateway_extranet/get_feature?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFeature(_response);
        });
    }

    protected processGetFeature(response: AxiosResponse): Promise<GetFeatureVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GetFeatureVo.fromJS(resultData200) : new GetFeatureVo();
            return result200;
        }
        return Promise.resolve<GetFeatureVo>(<any>null);
    }

    /**
     * resetExtranetConfig
     * @param configId configId
     * @return OK
     */
    resetExtranetConfig(configId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv1')+ "/gateway_extranet/reset?";
        if (configId === undefined || configId === null)
            throw new Error("The parameter 'configId' must be defined and cannot be null.");
        else
            url_ += "configId=" + encodeURIComponent("" + configId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetExtranetConfig(_response);
        });
    }

    protected processResetExtranetConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class BindFeatureDTO implements IBindFeatureDTO {
    gatewayCode!: string | undefined;
    workStationId!: string | undefined;

    constructor(data?: IBindFeatureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): BindFeatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BindFeatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IBindFeatureDTO {
    gatewayCode: string | undefined;
    workStationId: string | undefined;
}

export class DeviceExtranetConfigDTO implements IDeviceExtranetConfigDTO {
    /** 应用协议 */
    appProtocol!: string | undefined;
    /** 生产设备ID */
    deviceId!: string;
    /** IP */
    ip!: string | undefined;
    /** 端口 */
    port!: number | undefined;
    /** 协议 */
    protocol!: string | undefined;
    /** 虚拟IP */
    virtualIp!: string | undefined;
    /** 虚拟端口 */
    virtualPort!: number | undefined;

    constructor(data?: IDeviceExtranetConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appProtocol = data["appProtocol"];
            this.deviceId = data["deviceId"];
            this.ip = data["ip"];
            this.port = data["port"];
            this.protocol = data["protocol"];
            this.virtualIp = data["virtualIp"];
            this.virtualPort = data["virtualPort"];
        }
    }

    static fromJS(data: any): DeviceExtranetConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceExtranetConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appProtocol"] = this.appProtocol;
        data["deviceId"] = this.deviceId;
        data["ip"] = this.ip;
        data["port"] = this.port;
        data["protocol"] = this.protocol;
        data["virtualIp"] = this.virtualIp;
        data["virtualPort"] = this.virtualPort;
        return data; 
    }
}

export interface IDeviceExtranetConfigDTO {
    /** 应用协议 */
    appProtocol: string | undefined;
    /** 生产设备ID */
    deviceId: string;
    /** IP */
    ip: string | undefined;
    /** 端口 */
    port: number | undefined;
    /** 协议 */
    protocol: string | undefined;
    /** 虚拟IP */
    virtualIp: string | undefined;
    /** 虚拟端口 */
    virtualPort: number | undefined;
}

export class DeviceExtranetConfigVO implements IDeviceExtranetConfigVO {
    /** 应用协议 */
    appProtocol!: string | undefined;
    /** ID */
    id!: string | undefined;
    /** IP */
    ip!: string | undefined;
    /** 端口 */
    port!: number | undefined;
    /** 协议 */
    protocol!: string | undefined;
    /** 虚拟IP */
    virtualIp!: string | undefined;
    /** 虚拟端口 */
    virtualPort!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IDeviceExtranetConfigVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appProtocol = data["appProtocol"];
            this.id = data["id"];
            this.ip = data["ip"];
            this.port = data["port"];
            this.protocol = data["protocol"];
            this.virtualIp = data["virtualIp"];
            this.virtualPort = data["virtualPort"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceExtranetConfigVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceExtranetConfigVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appProtocol"] = this.appProtocol;
        data["id"] = this.id;
        data["ip"] = this.ip;
        data["port"] = this.port;
        data["protocol"] = this.protocol;
        data["virtualIp"] = this.virtualIp;
        data["virtualPort"] = this.virtualPort;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceExtranetConfigVO {
    /** 应用协议 */
    appProtocol: string | undefined;
    /** ID */
    id: string | undefined;
    /** IP */
    ip: string | undefined;
    /** 端口 */
    port: number | undefined;
    /** 协议 */
    protocol: string | undefined;
    /** 虚拟IP */
    virtualIp: string | undefined;
    /** 虚拟端口 */
    virtualPort: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class DeviceStateVo implements IDeviceStateVo {
    exist!: boolean | undefined;
    state!: string | undefined;

    constructor(data?: IDeviceStateVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exist = data["exist"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): DeviceStateVo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStateVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exist"] = this.exist;
        data["state"] = this.state;
        return data; 
    }
}

export interface IDeviceStateVo {
    exist: boolean | undefined;
    state: string | undefined;
}

export class DiagnosticRecordsDTO implements IDiagnosticRecordsDTO {
    /** 诊断提交人 */
    diagnosticPerson!: string | undefined;
    /** 诊断操作类型[可不填，或填3：手动中止诊断]，后续扩展可用 */
    diagnosticType!: number | undefined;
    /** 故障描述 */
    faultDesc!: string | undefined;
    /** 处理意见 */
    handleOpinion!: string | undefined;
    /** 工位id */
    workStationId!: string;

    constructor(data?: IDiagnosticRecordsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagnosticPerson = data["diagnosticPerson"];
            this.diagnosticType = data["diagnosticType"];
            this.faultDesc = data["faultDesc"];
            this.handleOpinion = data["handleOpinion"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DiagnosticRecordsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticRecordsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticPerson"] = this.diagnosticPerson;
        data["diagnosticType"] = this.diagnosticType;
        data["faultDesc"] = this.faultDesc;
        data["handleOpinion"] = this.handleOpinion;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDiagnosticRecordsDTO {
    /** 诊断提交人 */
    diagnosticPerson: string | undefined;
    /** 诊断操作类型[可不填，或填3：手动中止诊断]，后续扩展可用 */
    diagnosticType: number | undefined;
    /** 故障描述 */
    faultDesc: string | undefined;
    /** 处理意见 */
    handleOpinion: string | undefined;
    /** 工位id */
    workStationId: string;
}

export class DiagnosticRecordsPageDTO implements IDiagnosticRecordsPageDTO {
    /** 连接账户 */
    connectAccount!: string | undefined;
    /** 所属客户 */
    customerId!: string | undefined;
    /** 设备编号 */
    deviceCode!: string | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备类型 */
    deviceType!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 开始时间 */
    end!: Date | undefined;
    pageRequestDTO!: PageRequestDTO | undefined;
    /** 结束时间 */
    start!: Date | undefined;

    constructor(data?: IDiagnosticRecordsPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectAccount = data["connectAccount"];
            this.customerId = data["customerId"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceType = data["deviceType"];
            this.deviceTypeId = data["deviceTypeId"];
            this.end = data["end"] ? new Date(data["end"].toString()) : <any>undefined;
            this.pageRequestDTO = data["pageRequestDTO"] ? PageRequestDTO.fromJS(data["pageRequestDTO"]) : <any>undefined;
            this.start = data["start"] ? new Date(data["start"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DiagnosticRecordsPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticRecordsPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectAccount"] = this.connectAccount;
        data["customerId"] = this.customerId;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceType"] = this.deviceType;
        data["deviceTypeId"] = this.deviceTypeId;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["pageRequestDTO"] = this.pageRequestDTO ? this.pageRequestDTO.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDiagnosticRecordsPageDTO {
    /** 连接账户 */
    connectAccount: string | undefined;
    /** 所属客户 */
    customerId: string | undefined;
    /** 设备编号 */
    deviceCode: string | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备类型 */
    deviceType: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 开始时间 */
    end: Date | undefined;
    pageRequestDTO: PageRequestDTO | undefined;
    /** 结束时间 */
    start: Date | undefined;
}

export class DiagnosticRecordsVO implements IDiagnosticRecordsVO {
    /** 连接账户 */
    connectAccount!: string | undefined;
    /** 连接时间 */
    connectTime!: Date | undefined;
    /** 所属客户 */
    customer!: string | undefined;
    /** 设备编号 */
    deviceCode!: string | undefined;
    /** 设备类型 */
    deviceType!: string | undefined;
    /** 提交人 */
    diagnosticPerson!: string | undefined;
    /** 连接类型 */
    diagnosticType!: number | undefined;
    /** 故障描述 */
    faultDesc!: string | undefined;
    /** 处理意见 */
    handleOpinion!: string | undefined;
    /** 提交时间 */
    operationTime!: Date | undefined;
    workStationId!: string | undefined;

    constructor(data?: IDiagnosticRecordsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectAccount = data["connectAccount"];
            this.connectTime = data["connectTime"] ? new Date(data["connectTime"].toString()) : <any>undefined;
            this.customer = data["customer"];
            this.deviceCode = data["deviceCode"];
            this.deviceType = data["deviceType"];
            this.diagnosticPerson = data["diagnosticPerson"];
            this.diagnosticType = data["diagnosticType"];
            this.faultDesc = data["faultDesc"];
            this.handleOpinion = data["handleOpinion"];
            this.operationTime = data["operationTime"] ? new Date(data["operationTime"].toString()) : <any>undefined;
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DiagnosticRecordsVO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticRecordsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectAccount"] = this.connectAccount;
        data["connectTime"] = this.connectTime ? this.connectTime.toISOString() : <any>undefined;
        data["customer"] = this.customer;
        data["deviceCode"] = this.deviceCode;
        data["deviceType"] = this.deviceType;
        data["diagnosticPerson"] = this.diagnosticPerson;
        data["diagnosticType"] = this.diagnosticType;
        data["faultDesc"] = this.faultDesc;
        data["handleOpinion"] = this.handleOpinion;
        data["operationTime"] = this.operationTime ? this.operationTime.toISOString() : <any>undefined;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDiagnosticRecordsVO {
    /** 连接账户 */
    connectAccount: string | undefined;
    /** 连接时间 */
    connectTime: Date | undefined;
    /** 所属客户 */
    customer: string | undefined;
    /** 设备编号 */
    deviceCode: string | undefined;
    /** 设备类型 */
    deviceType: string | undefined;
    /** 提交人 */
    diagnosticPerson: string | undefined;
    /** 连接类型 */
    diagnosticType: number | undefined;
    /** 故障描述 */
    faultDesc: string | undefined;
    /** 处理意见 */
    handleOpinion: string | undefined;
    /** 提交时间 */
    operationTime: Date | undefined;
    workStationId: string | undefined;
}

export class ExtranetCodeVO implements IExtranetCodeVO {
    /** 诊断码 */
    code!: string | undefined;

    constructor(data?: IExtranetCodeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
        }
    }

    static fromJS(data: any): ExtranetCodeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtranetCodeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data; 
    }
}

export interface IExtranetCodeVO {
    /** 诊断码 */
    code: string | undefined;
}

export class ExtranetParamSetting implements IExtranetParamSetting {
    deleteEnable!: boolean | undefined;
    editEnable!: boolean | undefined;
    max!: number | undefined;
    tenantId!: string | undefined;

    constructor(data?: IExtranetParamSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deleteEnable = data["deleteEnable"];
            this.editEnable = data["editEnable"];
            this.max = data["max"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): ExtranetParamSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ExtranetParamSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleteEnable"] = this.deleteEnable;
        data["editEnable"] = this.editEnable;
        data["max"] = this.max;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IExtranetParamSetting {
    deleteEnable: boolean | undefined;
    editEnable: boolean | undefined;
    max: number | undefined;
    tenantId: string | undefined;
}

export class ExtranetSetting implements IExtranetSetting {
    appProtocol!: string | undefined;
    ip!: string | undefined;
    options!: string | undefined;
    port!: number | undefined;
    protocol!: string | undefined;
    virtualIp!: string | undefined;
    virtualPort!: number | undefined;

    constructor(data?: IExtranetSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appProtocol = data["appProtocol"];
            this.ip = data["ip"];
            this.options = data["options"];
            this.port = data["port"];
            this.protocol = data["protocol"];
            this.virtualIp = data["virtualIp"];
            this.virtualPort = data["virtualPort"];
        }
    }

    static fromJS(data: any): ExtranetSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ExtranetSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appProtocol"] = this.appProtocol;
        data["ip"] = this.ip;
        data["options"] = this.options;
        data["port"] = this.port;
        data["protocol"] = this.protocol;
        data["virtualIp"] = this.virtualIp;
        data["virtualPort"] = this.virtualPort;
        return data; 
    }
}

export interface IExtranetSetting {
    appProtocol: string | undefined;
    ip: string | undefined;
    options: string | undefined;
    port: number | undefined;
    protocol: string | undefined;
    virtualIp: string | undefined;
    virtualPort: number | undefined;
}

export class FindDeviceListDTO implements IFindDeviceListDTO {
    /** 区域列表 */
    areaNameList!: string[] | undefined;
    /** 客户Id */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 远程连接状态,0:未就绪, 1:就绪, 2:工作中 */
    extranetState!: number | undefined;
    /** 关键字 */
    filter!: string | undefined;
    query!: Query | undefined;

    constructor(data?: IFindDeviceListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["areaNameList"] && data["areaNameList"].constructor === Array) {
                this.areaNameList = [] as any;
                for (let item of data["areaNameList"])
                    this.areaNameList!.push(item);
            }
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.extranetState = data["extranetState"];
            this.filter = data["filter"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FindDeviceListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FindDeviceListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.areaNameList && this.areaNameList.constructor === Array) {
            data["areaNameList"] = [];
            for (let item of this.areaNameList)
                data["areaNameList"].push(item);
        }
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["extranetState"] = this.extranetState;
        data["filter"] = this.filter;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFindDeviceListDTO {
    /** 区域列表 */
    areaNameList: string[] | undefined;
    /** 客户Id */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 远程连接状态,0:未就绪, 1:就绪, 2:工作中 */
    extranetState: number | undefined;
    /** 关键字 */
    filter: string | undefined;
    query: Query | undefined;
}

export class GenerateExtranetCodeDTO implements IGenerateExtranetCodeDTO {
    /** 过期时间 */
    expireTime!: string | undefined;
    /** 设备Id[工位id] */
    workStationId!: string;

    constructor(data?: IGenerateExtranetCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.expireTime = data["expireTime"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): GenerateExtranetCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateExtranetCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expireTime"] = this.expireTime;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IGenerateExtranetCodeDTO {
    /** 过期时间 */
    expireTime: string | undefined;
    /** 设备Id[工位id] */
    workStationId: string;
}

export class GetFeatureVo implements IGetFeatureVo {
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    hasFeature!: boolean | undefined;

    constructor(data?: IGetFeatureVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.hasFeature = data["hasFeature"];
        }
    }

    static fromJS(data: any): GetFeatureVo {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeatureVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["hasFeature"] = this.hasFeature;
        return data; 
    }
}

export interface IGetFeatureVo {
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    hasFeature: boolean | undefined;
}

export class PageGroupWorkStationDTO implements IPageGroupWorkStationDTO {
    /** 工位组集合 */
    groups!: string[] | undefined;
    query!: Query | undefined;

    constructor(data?: IPageGroupWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [] as any;
                for (let item of data["groups"])
                    this.groups!.push(item);
            }
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PageGroupWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageGroupWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPageGroupWorkStationDTO {
    /** 工位组集合 */
    groups: string[] | undefined;
    query: Query | undefined;
}

export class PageRequestDTO implements IPageRequestDTO {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IPageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): PageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

export interface IPageRequestDTO {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

export class PageWorkStationDTO implements IPageWorkStationDTO {
    /** 过滤器[工位编号/名称] */
    filter!: string | undefined;
    query!: Query | undefined;

    constructor(data?: IPageWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PageWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPageWorkStationDTO {
    /** 过滤器[工位编号/名称] */
    filter: string | undefined;
    query: Query | undefined;
}

export class PagedResultVOOfDiagnosticRecordsVO implements IPagedResultVOOfDiagnosticRecordsVO {
    list!: DiagnosticRecordsVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfDiagnosticRecordsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(DiagnosticRecordsVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfDiagnosticRecordsVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfDiagnosticRecordsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfDiagnosticRecordsVO {
    list: DiagnosticRecordsVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfWorkStationExtranetInfoVO implements IPagedResultVOOfWorkStationExtranetInfoVO {
    list!: WorkStationExtranetInfoVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfWorkStationExtranetInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(WorkStationExtranetInfoVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfWorkStationExtranetInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfWorkStationExtranetInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfWorkStationExtranetInfoVO {
    list: WorkStationExtranetInfoVO[] | undefined;
    totalCount: number | undefined;
}

export class ProtocolVO implements IProtocolVO {
    /** 应用层协议集 */
    appProtocolList!: string[] | undefined;
    /** 传输层协议集 */
    protocolList!: string[] | undefined;

    constructor(data?: IProtocolVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["appProtocolList"] && data["appProtocolList"].constructor === Array) {
                this.appProtocolList = [] as any;
                for (let item of data["appProtocolList"])
                    this.appProtocolList!.push(item);
            }
            if (data["protocolList"] && data["protocolList"].constructor === Array) {
                this.protocolList = [] as any;
                for (let item of data["protocolList"])
                    this.protocolList!.push(item);
            }
        }
    }

    static fromJS(data: any): ProtocolVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProtocolVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.appProtocolList && this.appProtocolList.constructor === Array) {
            data["appProtocolList"] = [];
            for (let item of this.appProtocolList)
                data["appProtocolList"].push(item);
        }
        if (this.protocolList && this.protocolList.constructor === Array) {
            data["protocolList"] = [];
            for (let item of this.protocolList)
                data["protocolList"].push(item);
        }
        return data; 
    }
}

export interface IProtocolVO {
    /** 应用层协议集 */
    appProtocolList: string[] | undefined;
    /** 传输层协议集 */
    protocolList: string[] | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

/** 工位远程连接信息 */
export class WorkStationExtranetInfoVO implements IWorkStationExtranetInfoVO {
    /** 机床图片 */
    avatar!: string | undefined;
    /** 生产日历编码 */
    calendarCode!: string | undefined;
    /** 工位编号 */
    code!: string | undefined;
    /** 所属客户 */
    customerName!: string | undefined;
    /** 职权域id */
    deptId!: string | undefined;
    /** 机床型号 */
    equipmentModel!: string | undefined;
    /** 设备序列号 */
    equipmentSerialNumber!: string | undefined;
    /** 诊断码过期时间 */
    expiredDate!: Date | undefined;
    /** 诊断通道状态 */
    extranetChannelStatus!: boolean | undefined;
    /** 远程诊断码 */
    extranetCode!: string | undefined;
    /** 诊断网关SN */
    gatewayToken!: string | undefined;
    /** 工位id */
    id!: string | undefined;
    /** 工位名称 */
    name!: string | undefined;
    /** 工位类型 */
    type!: number | undefined;
    /** 设备可诊断状态[1 就绪; 2 工作中; 0/null 无法连接] */
    userVisibleStatus!: number | undefined;
    /** 等待生产日历编码 */
    waitingUpdateCalendar!: string | undefined;

    constructor(data?: IWorkStationExtranetInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.customerName = data["customerName"];
            this.deptId = data["deptId"];
            this.equipmentModel = data["equipmentModel"];
            this.equipmentSerialNumber = data["equipmentSerialNumber"];
            this.expiredDate = data["expiredDate"] ? new Date(data["expiredDate"].toString()) : <any>undefined;
            this.extranetChannelStatus = data["extranetChannelStatus"];
            this.extranetCode = data["extranetCode"];
            this.gatewayToken = data["gatewayToken"];
            this.id = data["id"];
            this.name = data["name"];
            this.type = data["type"];
            this.userVisibleStatus = data["userVisibleStatus"];
            this.waitingUpdateCalendar = data["waitingUpdateCalendar"];
        }
    }

    static fromJS(data: any): WorkStationExtranetInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationExtranetInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["customerName"] = this.customerName;
        data["deptId"] = this.deptId;
        data["equipmentModel"] = this.equipmentModel;
        data["equipmentSerialNumber"] = this.equipmentSerialNumber;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["extranetChannelStatus"] = this.extranetChannelStatus;
        data["extranetCode"] = this.extranetCode;
        data["gatewayToken"] = this.gatewayToken;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["userVisibleStatus"] = this.userVisibleStatus;
        data["waitingUpdateCalendar"] = this.waitingUpdateCalendar;
        return data; 
    }
}

/** 工位远程连接信息 */
export interface IWorkStationExtranetInfoVO {
    /** 机床图片 */
    avatar: string | undefined;
    /** 生产日历编码 */
    calendarCode: string | undefined;
    /** 工位编号 */
    code: string | undefined;
    /** 所属客户 */
    customerName: string | undefined;
    /** 职权域id */
    deptId: string | undefined;
    /** 机床型号 */
    equipmentModel: string | undefined;
    /** 设备序列号 */
    equipmentSerialNumber: string | undefined;
    /** 诊断码过期时间 */
    expiredDate: Date | undefined;
    /** 诊断通道状态 */
    extranetChannelStatus: boolean | undefined;
    /** 远程诊断码 */
    extranetCode: string | undefined;
    /** 诊断网关SN */
    gatewayToken: string | undefined;
    /** 工位id */
    id: string | undefined;
    /** 工位名称 */
    name: string | undefined;
    /** 工位类型 */
    type: number | undefined;
    /** 设备可诊断状态[1 就绪; 2 工作中; 0/null 无法连接] */
    userVisibleStatus: number | undefined;
    /** 等待生产日历编码 */
    waitingUpdateCalendar: string | undefined;
}